import AllStock from './AllStock';
export default AllStock;
